import { Component } from "@angular/core";

@Component({
  selector: "vc-link-button",
  templateUrl: "./link-button.component.html",
  styleUrls: ["./link-button.component.scss"],
})
export class LinkButtonComponent { }
